import React from 'react';

import './gradient.css';

export default function Gradient () {
    return (
        <div className="gradient">
            <div className="gradient-green-top"></div>
            <div className="gradient-bottom"></div>
        </div>
    );
}